var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37188 9.37569C6.47931 9.37569 5.55757 9.154 4.63 8.71939C3.90369 8.37811 3.17155 7.90557 2.454 7.31344C1.24349 6.31295 0.496761 5.3212 0.464675 5.28037C0.339249 5.1141 0.339249 4.88658 0.464675 4.72032C0.496761 4.67948 1.24349 3.68774 2.454 2.68725C3.17155 2.09512 3.90369 1.62258 4.63 1.2813C5.55757 0.846684 6.47931 0.625 7.37188 0.625C8.26445 0.625 9.18619 0.846684 10.1138 1.2813C10.8401 1.62258 11.5722 2.09512 12.2898 2.68725C13.5003 3.68774 14.2499 4.67948 14.2791 4.72032C14.4045 4.88658 14.4045 5.1141 14.2791 5.28037C14.247 5.3212 13.5003 6.31295 12.2898 7.31344C11.5722 7.90557 10.8401 8.37811 10.1138 8.71939C9.18619 9.154 8.26445 9.37569 7.37188 9.37569ZM1.43892 5.00034C2.17106 5.86666 4.58917 8.44228 7.37188 8.44228C10.1604 8.44228 12.5727 5.86666 13.3048 5.00034C12.5727 4.13403 10.1546 1.55841 7.37188 1.55841C4.58333 1.55841 2.17106 4.13403 1.43892 5.00034Z",
    fill: "#7D7C80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37189 7.10072C6.21389 7.10072 5.27173 6.15856 5.27173 5.00056C5.27173 3.84255 6.21389 2.90039 7.37189 2.90039C8.5299 2.90039 9.47206 3.84255 9.47206 5.00056C9.47206 6.15856 8.5299 7.10072 7.37189 7.10072ZM7.37189 3.8338C6.72726 3.8338 6.20514 4.35592 6.20514 5.00056C6.20514 5.64519 6.72726 6.16731 7.37189 6.16731C8.01653 6.16731 8.53865 5.64519 8.53865 5.00056C8.53865 4.35592 8.01653 3.8338 7.37189 3.8338Z",
    fill: "#7D7C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowEyeIcon);
export default __webpack_public_path__ + "static/media/show-eye-icon.394575f9e53d52907408696a3e1bd175.svg";
export { ForwardRef as ReactComponent };